import { Controller } from "@hotwired/stimulus"
import { logger } from "../utilities/logger"

export default class extends Controller {
  connect() {
    logger.log("Modal controller connected")
    logger.log("Element:", this.element)

    // Auto-show modal when loaded via Turbo Frame (Bootstrap 5 vanilla JS)
    const modal = new bootstrap.Modal(this.element)
    modal.show()

    // Clean up turbo frame after modal is hidden
    this.element.addEventListener('hidden.bs.modal', () => {
      logger.log("Modal hidden, clearing turbo frame")
      // Clear the turbo frame content
      const frame = this.element.closest('turbo-frame')
      if (frame) {
        frame.innerHTML = ''
      }
    }, { once: true })
  }

  disable(event) {
    logger.log("Disabling button")
    const button = event.currentTarget
    button.classList.add('disabled')
    const originalText = button.textContent.trim()
    button.innerHTML = originalText + '...'
  }
}
